export default {
  Equals: '=',
  GreaterThan: '>',
  LessThan: '<',
  GreaterThanEquals: '>=',
  LessThanEquals: '<=',
  NotEquals: '!=',
  In: 'IN',
};
